import Vue from 'vue'
import {
  RESET_STATE,
  UPDATE_IDTOKEN,
  UPDATE_IDTOKEN_EXPIRED,
  UPDATE_DEALER_LOGO
} from '../mutation-types'

let initialState = {
  idToken: null,
  isIdTokenExpired: false,
  dealerLogo: 'test'
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  idToken: function (state) {
    return state.idToken
  },
  isIdTokenExpired: function (state) {
    return state.isIdTokenExpired
  },
  dealerLogo: function (state) {
    return state.dealerLogo
  }
}

// mutations
const mutations = {
  [RESET_STATE]: function (state) {
    for (let f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
  [UPDATE_IDTOKEN]: function (state, {idToken}) {
    state.idToken = idToken
  },
  [UPDATE_IDTOKEN_EXPIRED]: function (state, {isExpired}) {
    state.isIdTokenExpired = isExpired
  },
  [UPDATE_DEALER_LOGO]: function (state, {dealerLogo}) {
    state.dealerLogo = dealerLogo
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/token.js